module.exports = __webpack_public_path__ + "img/aej1n-66wvl.015.dcf5afbe.png";